"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _router = require("next/router");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Search = require("@commerce-ui/core2/Search");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _useQuickSearch = _interopRequireDefault(require("@deosite/api/hooks/REST/useQuickSearch"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _ProductRow = _interopRequireDefault(require("../ProductRow"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _bodyScrollLock = require("@deosite/lib/bodyScrollLock");
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var IconSearch = function IconSearch(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
IconSearch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchMobile = function SearchMobile(props) {
  var _popularSearches$cont;
  var popularSearches = props.popularSearches,
    closeSearch = props.closeSearch,
    inputBare = props.inputBare,
    mobileSearchOpen = props.mobileSearchOpen;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useSearch = (0, _useQuickSearch["default"])(language),
    _useSearch$state = _useSearch.state,
    state = _useSearch$state === void 0 ? {} : _useSearch$state,
    setPhrase = _useSearch.setPhrase,
    phrase = _useSearch.phrase;
  var _state$data = state.data,
    data = _state$data === void 0 ? [] : _state$data;
  var _data$results = data.results,
    results = _data$results === void 0 ? [] : _data$results,
    _data$totalCount = data.totalCount,
    totalCount = _data$totalCount === void 0 ? null : _data$totalCount,
    _data$categories = data.categories,
    categories = _data$categories === void 0 ? [] : _data$categories;
  var router = (0, _router.useRouter)();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    popularSearches: (0, _langLibrary["default"])("Popular searches"),
    cancel: (0, _langLibrary["default"])("Cancel"),
    searchCollection: (0, _langLibrary["default"])("Search collections, products, etc..."),
    seeAllSuggestions: (0, _langLibrary["default"])("See all suggestions ({{resultsLength}})", {
      resultsLength: totalCount
    })
  };
  var popularSearchesContent = global.__appConfig__.popularSearchesFromJson ? popularSearches !== null && popularSearches !== void 0 ? popularSearches : {} : (_popularSearches$cont = popularSearches.content) === null || _popularSearches$cont === void 0 ? void 0 : _popularSearches$cont.popularSearches;
  var handleCloseSearch = function handleCloseSearch() {
    setPhrase(null);
    closeSearch(false);
  };
  var popularSearchesView = __jsx(_Box["default"], {
    sx: {
      ml: "6vw",
      mr: "6vw"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "xxs_caps_ext",
      color: "neutral700",
      textDecoration: "uppercase",
      pt: "s8",
      mb: "s7"
    }
  }, translations.popularSearches), popularSearches && (popularSearchesContent === null || popularSearchesContent === void 0 ? void 0 : popularSearchesContent.map(function (searchResult, index) {
    return searchResult && __jsx(_Box["default"], {
      sx: {
        color: "main",
        font: "l_normal",
        textDecoration: "none",
        ":hover": {
          bg: "neutral100"
        },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "1",
        overflow: "hidden",
        py: "s4"
      },
      key: index
    }, __jsx(Link, {
      route: "category-page",
      params: searchResult
    }, __jsx(_LinkRaw["default"], {
      title: searchResult.title,
      onClick: function onClick() {
        return handleCloseSearch();
      }
    }, searchResult.title)));
  })));
  var searchInput = /*#__PURE__*/_react["default"].cloneElement(inputBare, {
    placeholder: translations.searchCollection,
    leftEnhancer: __jsx(IconSearch, null),
    autoFocus: true,
    clearable: true,
    "data-test": "search-mobile"
  });
  (0, _react.useEffect)(function () {
    var _document;
    var element = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById("layerUi");
    if (mobileSearchOpen) {
      (0, _bodyScrollLock.disableBodyScroll)(element);
    } else {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    }
  }, [mobileSearchOpen]);
  return __jsx(_Search.SearchInline, {
    input: searchInput,
    mode: "fixed",
    inputContainer: function inputContainer(_ref) {
      var input = _ref.input;
      return __jsx(_Box["default"], {
        sx: {
          p: "s3",
          borderBottomStyle: "solid",
          borderBottomColor: "neutral",
          borderBottomWidth: "1px",
          bg: "white"
        }
      }, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, __jsx(_Box["default"], {
        sx: {
          flex: "1 1 auto"
        }
      }, input), __jsx(_Box["default"], {
        sx: {
          flex: "0 0 auto",
          pr: "s6"
        },
        onClick: function onClick() {
          return handleCloseSearch();
        }
      }, __jsx(_Box["default"], {
        sx: {
          color: "active",
          font: "base_sans",
          cursor: "pointer"
        }
      }, translations.cancel))));
    },
    onChange: function onChange(val) {
      return setPhrase(val);
    },
    onSubmit: function onSubmit(val) {
      handleCloseSearch();
      if ((results === null || results === void 0 ? void 0 : results.length) === 1) {
        router.push("/[...categoryOrProductPage]", "/".concat(results[0].url));
      } else {
        router.push("/catalogsearch/result/[...query]/", "/catalogsearch/result/".concat(val));
      }
    }
  }, !phrase || (phrase === null || phrase === void 0 ? void 0 : phrase.length) === 0 ? popularSearchesView : (results === null || results === void 0 ? void 0 : results.length) > 0 && __jsx(_Box["default"], {
    sx: {
      py: "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      ml: "6vw",
      mr: "6vw"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "l_normal",
      textDecoration: "none"
    }
  }, categories.slice(0, 3).map(function (item) {
    return __jsx(Link, {
      route: "product-page",
      params: item,
      key: item.id
    }, __jsx(_LinkRaw["default"], {
      sx: {
        ":hover": {
          bg: "neutral100"
        },
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "1",
        overflow: "hidden",
        py: "s4"
      },
      title: item.name,
      onClick: function onClick() {
        return handleCloseSearch();
      }
    }, item.name));
  })), __jsx(_Box["default"], {
    sx: {
      mt: "s9"
    }
  }, (results === null || results === void 0 ? void 0 : results.length) > 0 && results.slice(0, 5).map(function (item) {
    return __jsx(_Box["default"], {
      sx: {
        height: "80px",
        mb: "s8"
      },
      key: item.id
    }, __jsx(_ProductRow["default"], {
      product: item,
      quantity: 1,
      isQuantityPickerEnabled: false,
      onLinkClick: handleCloseSearch
    }));
  }), results.length > 0 && __jsx(Link, {
    route: "catalogsearch",
    params: {
      query: phrase
    }
  }, __jsx(_LinkRaw["default"], {
    title: translations.seeAllSuggestions,
    onClick: function onClick() {
      return handleCloseSearch();
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "base_sans_bold",
      pt: "s6",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: "24px"
    }
  }, " ", translations.seeAllSuggestions, " "), " ", __jsx(_Box["default"], {
    sx: {
      ml: "s6"
    }
  }, __jsx(ArrowRightIcon, null)))))))));
};
var _default = SearchMobile;
exports["default"] = _default;